// extracted by mini-css-extract-plugin
module.exports = {"summaryInfoListItem":"SummaryInfoListItem_summaryInfoListItem__1CapW","chip":"SummaryInfoListItem_chip__3vyv2"};